// A snow-laden fir: dark green stacked cones each topped with a smaller white
// snow cap, so it reads as frosted. Ported 1:1 from age-of-mcp's classic
// tree-snow-fir.ts.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  return [
    { geometry: new THREE.CylinderGeometry(0.06, 0.1, 0.28, 5),
      color: "#3a2c1e", position: [0, 0.14, 0] },
    { geometry: new THREE.ConeGeometry(0.56, 0.72, 7),
      color: "#2c5742", position: [0, 0.58, 0] },
    { geometry: new THREE.ConeGeometry(0.42, 0.36, 7),
      color: "#eef4f8", position: [0, 0.82, 0] },     // snow on lower tier
    { geometry: new THREE.ConeGeometry(0.42, 0.66, 7),
      color: "#326049", position: [0, 1.0, 0] },
    { geometry: new THREE.ConeGeometry(0.3, 0.34, 7),
      color: "#eef4f8", position: [0, 1.22, 0] },      // snow on upper tier
    { geometry: new THREE.ConeGeometry(0.26, 0.58, 7),
      color: "#39704f", position: [0, 1.4, 0] },
    { geometry: new THREE.ConeGeometry(0.16, 0.3, 7),
      color: "#ffffff", position: [0, 1.62, 0] },      // snowy tip
  ];
}

export const treeSnowFir = defineModel({
  id: "tree-snow-fir",
  batchId: "standard",
  name: "Tree snow fir",
  tags: ["scenery","tree","snow","fir","low-poly","age-of-mcp","classic"],
  summary: "Low-poly tree snow fir.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.5,
  parts: () => partsFor(),
  animations: [],
});
